import { Box, Button, Dialog, Typography } from '@mui/material';

interface IProps {
  unmount: () => void;
  refetch: () => void;
}

export const NoDataDialog = ({ unmount, refetch }: IProps) => (
  <Dialog open onClose={unmount} maxWidth='lg' fullWidth scroll='paper'>
    <Box
      sx={{
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Typography variant='h6'>
        Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.
      </Typography>
      <Button variant='contained' onClick={() => refetch()}>
        Erneut versuchen
      </Button>
    </Box>
  </Dialog>
);
